module.exports = __webpack_public_path__ + "static/daiwa-roynet-hotel-a88a692144b4af6c42b2edb2b23e122d.jpg";